import * as yup from 'yup';
import i18n from "../utils/lang/i18n";
export const invalidInputs = [null, 'null', 'undefined', undefined, ''];
export const reqMsg = i18n.t('Input is required');


export const reqString = yup
  .string()
  .required(reqMsg)
  .min(1, reqMsg)
  .nullable(true);
export const reqObject = yup
  .object()
  .required(reqMsg)
  .nullable(true);

export const reqArray = yup
  .array()
  .ensure()
  .required(reqMsg)
  .min(1);
export const ensureArray = yup.array().ensure();

export const reqPositiveInteger = yup
  .number()
  .required(reqMsg)
  .positive()
  .integer();

export const validateString = yup.string().notOneOf(invalidInputs, reqMsg);

export const reqEmail = yup
  .string()
  .email(i18n.t('Must be a valid email'))
  .required(i18n.t('Email is required'));

export const validateEmail = yup
  .string()
  .nullable()
  .notRequired()
  .email(i18n.t('Must be a valid email'));

export const reqDate = yup
  .date()
  .required(reqMsg)
  .nullable(true);
